import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/column";
// 栏目
const columnApi = {
  // 栏目列表(不区分是否显示)
  list() {
    return request({
      url: `${baseUrl}/listAll`,
      method: "GET"
    });
  },

  // 网站栏目列表树(仅显示)
  menuTree() {
    return request({
      url: `${baseUrl}/tree`,
      method: "GET"
    });
  }
};

export default columnApi;
